export const TYPE_LABEL = { agent_execution: 'EXE', access_grant: 'ACCESS' };

export const TRIGGER_LIST_GRID_COLUMNS = '80px 140px 80px 140px 120px 1fr 160px 48px';

export function getTagLabel(trigger) {
  return trigger.doc_tag?.name ?? (trigger.cgpt_doc_tag_id != null ? `Tag ${trigger.cgpt_doc_tag_id}` : '—');
}

export function getAgentLabel(trigger) {
  return trigger.trigger_type === 'agent_execution' ? trigger.agent_name || '—' : '—';
}

export function getUserIdLabel(trigger) {
  return trigger.share_with_user_id != null ? String(trigger.share_with_user_id) : '—';
}

export function getAllowConcurrencyLabel(trigger) {
  if (trigger.trigger_type !== 'agent_execution') return '—';
  if (trigger.allow_concurrency === true) return 'Yes';
  if (trigger.allow_concurrency === false) return 'No';
  return '—';
}
